import View from "../framework/view";
import {Extra} from "../bo/extras";
import template from "../../pugc/extras";
import { renderDollars } from "../misc/utils";
import {Choice} from "../bo/product";
import {AusDollar} from "../misc/types";
import jQuery from "jquery";

const classname = "extras-view";

interface OptionChoice extends Choice {
    optionName: string;
    selectionName?: string;
}

export function parsePrice(price: any) : AusDollar {
    if (price == undefined) {
        return NaN;
    }

    price = String(price);
    price = price.replace(/^.*\$/, "");
    return Number(price);
}


export class ExtrasModel {

    extrasAvailable : Extra[] = [];

    currentExtras : Extra | undefined = undefined;

    addedExtras : OptionChoice[] = [];

    onChange?: () => void;
}

export class ExtrasView extends View {

    private model: ExtrasModel;

    constructor(model: ExtrasModel) {
        super(classname);
        this.model = model;
    }

    render0() {

        const data = {
            ... this.model,
            parsePrice: parsePrice,
            renderDollars: renderDollars,
        };

        const out = this.pug(template, data);

        return out;
    }

    showExtra(extra: string) {
        const f = this.model.extrasAvailable.filter((x: any) => x.name == extra);
        this.model.currentExtras = f.length > 0 ? f[0] : undefined;
        this.update(".extras-modal");
    }

    addExtra(option: string) {
        if (! this.model.currentExtras || ! this.model.currentExtras.choices) {
            return;
        }
        const options = this.model.currentExtras.choices.filter((x: any) => x.description == option);
        if (options.length == 0) {
            return;
        }
        const opt = options[0];
        this.model.addedExtras.push({
            optionName: this.model.currentExtras.name as string,
            value: opt.value,
            description: opt.description,
            media: opt.media
        });
        this.model.currentExtras = undefined;
        this.update();
        this.model.onChange && this.model.onChange();
    }

    removeExtra(idx: number) {
        this.model.addedExtras.splice(idx, 1);
        this.update();
        this.model.onChange && this.model.onChange();
    }

}

View.on(
    "." + classname,
    "click",
    ".gift, .gift img",
    function(that: ExtrasView, event, elt) {
        that.showExtra(jQuery(elt).closest(".gift").data("extra"))
    });

View.on(
    "." + classname,
    "click",
    ".option, .option img",
    function(that: ExtrasView, event, elt) {
        that.addExtra(jQuery(elt).closest(".option").data("option"))
    });

View.on(
    "." + classname,
    "click",
    ".extra .remove",
    function(that: ExtrasView, event, elt) {
        that.removeExtra(jQuery(elt).data("idx"))
    });
